import { createStore } from "vuex";

export const dataHome = createStore({
  state: () => ({
    newWithdraw: {
      employee: undefined,
      item: [],
      reason: undefined,
      company_id: undefined,
      itensSelected: [],
    },
  }),

  getters: {
    itensSelected: (state) => state.newWithdraw.itensSelected,
    getValueItnsSelected: (state) => state.newWithdraw.itensSelected,
  },

  mutations: {
    reset(state) {
      state.newWithdraw.employee = undefined;
      state.newWithdraw.item = [];
      state.newWithdraw.reason = undefined;
      state.newWithdraw.itensSelected = [];
    },

    SET_EMPLOYEE(state, employee) {
      state.newWithdraw.employee = employee;
    },

    SET_COLLECT_ITEMS(state, items) {
      state.newWithdraw.itensSelected = items;
      state.newWithdraw.item = items;
    },

    SET_COLLECT_VALUE(state, value) {
      state.newWithdraw.itensSelected.push(value);
      state.newWithdraw.item = state.newWithdraw.itensSelected;
    },

    UPDATE_ITEM_BY_COLLECT_VALUE(state, updatedItem) {
      const index = state.newWithdraw.itensSelected.findIndex(
        (item) => item.id === updatedItem.id
      );

      if (index !== -1) {
        state.newWithdraw.itensSelected.splice(index, 1, updatedItem);
        state.newWithdraw.item = state.newWithdraw.itensSelected;
      }
    },

    REMOVE_ITEM_BY_COLLECT_VALUE(state, itemId) {
      state.newWithdraw.itensSelected = state.newWithdraw.itensSelected.filter(
        (item) => item.id !== itemId
      );

      state.newWithdraw.item = state.newWithdraw.itensSelected;
    },

    CLEN_COLLECT(state) {
      state.newWithdraw.itensSelected = [];
      state.newWithdraw.item = [];
    },
  },

  actions: {
    reset({ commit }) {
      commit("reset");
    },
    cleanCollect({ commit }) {
      commit("CLEN_COLLECT");
    },
    setEmployee({ commit }, val) {
      commit("SET_EMPLOYEE", val);
    },
    setCollectItems({ commit }, val) {
      commit("SET_COLLECT_ITEMS", val);
    },
    setCollectValue({ commit }, val) {
      commit("SET_COLLECT_VALUE", val);
    },
    removeItemByCollectValue({ commit }, val) {
      commit("REMOVE_ITEM_BY_COLLECT_VALUE", val);
    },
    updateItemByCollectValue({ commit }, val) {
      commit("UPDATE_ITEM_BY_COLLECT_VALUE", val);
    },
  },
});
